<div id="registration-page" class="body-padding-start-window">
  @if (!registrationCompleted) {
    <div id="registration-form-container" class="form-container">
      <span id="registration-title" class="special-font font-bold text-xl">Request an Account</span>
      <div class="flex">
        <div class="w-full mx-auto">
          <form id="registration-form" [formGroup]="registrationForm">
            <div class="mb-3 mt-5">
              <label for="registration-firstname-input" class="form-input-label">
                First Name<span class="text-red-600">*</span>
              </label>
              <input id="registration-firstname-input" formControlName="firstName" class="form-input" placeholder="John"
                     required>
              @if (isInvalidAndTouched('firstName')) {
                <div id="registration-firstname-error"
                     class="flex gap-2 text-xs pt-2 text-red-500">
                  <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                  @if (registrationForm.controls['firstName'].errors?.['required']) {
                    <span>First Name is required.</span>
                  }
                </div>
              }
            </div>
            <div class="mb-3">
              <label for="registration-lastname-input" class="form-input-label">
                Last Name<span class="text-red-600">*</span>
              </label>
              <input id="registration-lastname-input" formControlName="lastName" class="form-input" placeholder="Smith"
                     required>
              @if (isInvalidAndTouched('lastName')) {
                <div id="registration-lastname-error"
                     class="flex gap-2 text-xs pt-2 text-red-500">
                  <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                  @if (registrationForm.controls['lastName'].errors?.['required']) {
                    <span>Last Name is required.</span>
                  }
                </div>
              }
            </div>
            <div class="mb-3">
              <label for="registration-company-input" class="form-input-label">
                Company<span class="text-red-600">*</span>
              </label>
              <input id="registration-company-input" formControlName="company" class="form-input"
                     placeholder="Enter your company name" required>
              @if (isInvalidAndTouched('company')) {
                <div id="registration-company-error"
                     class="flex gap-2 text-xs pt-2 text-red-500">
                  <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                  @if (registrationForm.controls['company'].errors?.['required']) {
                    <span>Company is required.</span>
                  }
                </div>
              }
            </div>
            <div class="mb-3">
              <label for="registration-phone-input" class="form-input-label">Phone</label>
              <input id="registration-phone-input" formControlName="phone" type="text" class="form-input"
                     placeholder="+1 (XXX) XXX-XXXX">
            </div>
            <div class="mb-3 mt-6">
              <label for="registration-email-input" class="form-input-label">
                Work Email<span class="text-red-600">*</span>
              </label>
              <input id="registration-email-input" formControlName="email" type="email" class="form-input"
                     placeholder="name@company.com" autocomplete="false" required>
              @if (isInvalidAndTouched('email')) {
                <div id="registration-email-error"
                     class="flex gap-2 text-xs pt-2 text-red-500">
                  <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                  @if (registrationForm.controls['email'].errors?.['required']) {
                    <span>Email is required.</span>
                  }
                  @if (registrationForm.controls['email'].errors?.['pattern']) {
                    <span>Email format is invalid.</span>
                  }
                </div>
              }
            </div>
            <div class="mb-3">
              <label for="registration-password-input" class="form-input-label">
                Password<span class="text-red-600">*</span>
              </label>
              <div class="relative w-full">
                <input id="registration-password-input" formControlName="password" autocomplete="false"
                       placeholder="***************" [type]="!isConfirmPasswordShown ? 'password' : 'text'"
                       class="form-input" required>
                <button id="registration-password-toggle"
                        (click)="toggleShowConfirmPassword()"
                        type="button"
                        class="absolute top-0 end-0 p-2.5 h-full text-sm font-medium text-white bg-[#FDDE64] rounded-e-lg border border-[#FDDE64] hover:bg-[#FDDE64]">
                  @if (isConfirmPasswordShown) {
                    <svg height="20" viewBox="0 0 48 48" width="20"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h48v48h-48z" fill="none"/>
                      <path
                        d="M24 9c-10 0-18.54 6.22-22 15 3.46 8.78 12 15 22 15 10.01 0 18.54-6.22 22-15-3.46-8.78-11.99-15-22-15zm0 25c-5.52 0-10-4.48-10-10s4.48-10 10-10 10 4.48 10 10-4.48 10-10 10zm0-16c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"/>
                    </svg>
                  } @else {
                    <svg height="20" viewBox="0 0 48 48" width="20"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h48v48h-48zm0 0h48v48h-48zm0 0h48v48h-48zm0 0h48v48h-48z" fill="none"/>
                      <path
                        d="M24 14c5.52 0 10 4.48 10 10 0 1.29-.26 2.52-.71 3.65l5.85 5.85c3.02-2.52 5.4-5.78 6.87-9.5-3.47-8.78-12-15-22.01-15-2.8 0-5.48.5-7.97 1.4l4.32 4.31c1.13-.44 2.36-.71 3.65-.71zm-20-5.45l4.56 4.56.91.91c-3.3 2.58-5.91 6.01-7.47 9.98 3.46 8.78 12 15 22 15 3.1 0 6.06-.6 8.77-1.69l.85.85 5.83 5.84 2.55-2.54-35.45-35.46-2.55 2.55zm11.06 11.05l3.09 3.09c-.09.43-.15.86-.15 1.31 0 3.31 2.69 6 6 6 .45 0 .88-.06 1.3-.15l3.09 3.09c-1.33.66-2.81 1.06-4.39 1.06-5.52 0-10-4.48-10-10 0-1.58.4-3.06 1.06-4.4zm8.61-1.57l6.3 6.3.03-.33c0-3.31-2.69-6-6-6l-.33.03z"/>
                    </svg>
                  }
                </button>
              </div>
              @if (isInvalidAndTouched('password')) {
                <div id="registration-password-error"
                     class="flex gap-2 text-xs pt-2 text-red-500">
                  <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                  @if (registrationForm.controls['password'].errors?.['required']) {
                    <span>Password is required.</span>
                  }
                  @if (registrationForm.controls['password'].errors?.['minlength']) {
                    <span>Password is too short.</span>
                  }
                </div>
              }
            </div>
            <div class="mb-5">
              <label for="registration-confirm-password-input" class="form-input-label">
                Confirm Password<span class="text-red-600">*</span>
              </label>
              <div class="relative w-full">
                <input id="registration-confirm-password-input" formControlName="confirmPassword"
                       placeholder="***************" [type]="!isPasswordShown ? 'password' : 'text'"
                       autocomplete="false" class="form-input" required>
                <button id="registration-confirm-password-toggle"
                        (click)="toggleShowPassword()"
                        type="button"
                        class="absolute top-0 end-0 p-2.5 h-full text-sm font-medium text-white bg-[#FDDE64] rounded-e-lg border border-[#FDDE64] hover:bg-[#FDDE64]">
                  @if (isPasswordShown) {
                    <svg height="20" viewBox="0 0 48 48" width="20"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h48v48h-48z" fill="none"/>
                      <path
                        d="M24 9c-10 0-18.54 6.22-22 15 3.46 8.78 12 15 22 15 10.01 0 18.54-6.22 22-15-3.46-8.78-11.99-15-22-15zm0 25c-5.52 0-10-4.48-10-10s4.48-10 10-10 10 4.48 10 10-4.48 10-10 10zm0-16c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"/>
                    </svg>
                  } @else {
                    <svg height="20" viewBox="0 0 48 48" width="20"
                         xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0h48v48h-48zm0 0h48v48h-48zm0 0h48v48h-48zm0 0h48v48h-48z" fill="none"/>
                      <path
                        d="M24 14c5.52 0 10 4.48 10 10 0 1.29-.26 2.52-.71 3.65l5.85 5.85c3.02-2.52 5.4-5.78 6.87-9.5-3.47-8.78-12-15-22.01-15-2.8 0-5.48.5-7.97 1.4l4.32 4.31c1.13-.44 2.36-.71 3.65-.71zm-20-5.45l4.56 4.56.91.91c-3.3 2.58-5.91 6.01-7.47 9.98 3.46 8.78 12 15 22 15 3.1 0 6.06-.6 8.77-1.69l.85.85 5.83 5.84 2.55-2.54-35.45-35.46-2.55 2.55zm11.06 11.05l3.09 3.09c-.09.43-.15.86-.15 1.31 0 3.31 2.69 6 6 6 .45 0 .88-.06 1.3-.15l3.09 3.09c-1.33.66-2.81 1.06-4.39 1.06-5.52 0-10-4.48-10-10 0-1.58.4-3.06 1.06-4.4zm8.61-1.57l6.3 6.3.03-.33c0-3.31-2.69-6-6-6l-.33.03z"/>
                    </svg>
                  }
                </button>
              </div>
              @if (isInvalidAndTouched('confirmPassword')) {
                <div id="registration-confirm-password-error"
                     class="flex gap-2 text-xs pt-2 text-red-500">
                  <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                  @if (registrationForm.controls['confirmPassword'].errors?.['required']) {
                    <span>Confirm Password is required.</span>
                  }
                  @if (registrationForm.controls['confirmPassword'].errors?.['pattern']) {
                    <span>Confirm Password format is invalid.</span>
                  }
                  @if (registrationForm.controls['confirmPassword'].errors?.['mustMatch']) {
                    <span>Passwords do not match.</span>
                  }
                </div>
              }
            </div>
            <button id="registration-submit-btn" (click)="register()" type="button" class="submit-button-forms">
              Request an Account
            </button>
          </form>
        </div>
      </div>
    </div>
  } @else {
    <div id="registration-success-container" class="form-container">
      <span id="registration-success-title" class="special-font font-bold text-xl pb-3">Please verify your email</span>
      <div class="flex">
        <div class="text-base font-base">
          <span id="registration-success-text-1"
                class="text-black font-['Inter']">You're almost there! We sent an email to </span>
          <span id="registration-success-email"
                class="text-blue-400">{{ registeredEmail }}<br/></span>
          <span id="registration-success-text-2"
                class="text-black font-['Inter']">Please click on the link in that email to proceed with your account registration. <br/>If you don't see it, you may need to check your spam folder. <br/><br/></span>
        </div>
      </div>
    </div>
  }
</div>
